export const GridIcon = ({ className, color = "currentColor" }: { className?: string; color?: string }) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.16667 2.16669H3.5C2.76362 2.16669 2.16667 2.76364 2.16667 3.50002V6.16669C2.16667 6.90307 2.76362 7.50002 3.5 7.50002H6.16667C6.90305 7.50002 7.5 6.90307 7.5 6.16669V3.50002C7.5 2.76364 6.90305 2.16669 6.16667 2.16669Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5 2.16669H10.8333C10.0969 2.16669 9.5 2.76364 9.5 3.50002V6.16669C9.5 6.90307 10.0969 7.50002 10.8333 7.50002H13.5C14.2364 7.50002 14.8333 6.90307 14.8333 6.16669V3.50002C14.8333 2.76364 14.2364 2.16669 13.5 2.16669Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.16667 9.50002H3.5C2.76362 9.50002 2.16667 10.097 2.16667 10.8334V13.5C2.16667 14.2364 2.76362 14.8334 3.5 14.8334H6.16667C6.90305 14.8334 7.5 14.2364 7.5 13.5V10.8334C7.5 10.097 6.90305 9.50002 6.16667 9.50002Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5 9.50002H10.8333C10.0969 9.50002 9.5 10.097 9.5 10.8334V13.5C9.5 14.2364 10.0969 14.8334 10.8333 14.8334H13.5C14.2364 14.8334 14.8333 14.2364 14.8333 13.5V10.8334C14.8333 10.097 14.2364 9.50002 13.5 9.50002Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
